export default {
  header: {
    signIn: 'サインイン',
    signUp: '新規登録'
  },
  userMenu: {
    wallet: 'ウォレット',
    withdraw: '出金',
    transaction: '取引履歴',
    myBet: 'ベット履歴',
    rollover: 'ロールオーバー',
    vault: '金庫',
    profile: 'プロフィール',
    settings: '設定',
    signOut: 'ログアウト',
    signOutTitle: 'ログアウト',
    signOutContent: '報酬とスリリングなゲームに満ちた世界を探索しましょう！',
    signOutConfirm: 'ログアウト',
    cancel: 'キャンセル'
  }
};
